import styles from "./skeleton.module.css";

// A shimmering placeholder block where content is still loading. width and
// height take any CSS length (a number is px).
const Skeleton = ({ width = "100%", height = 12, radius = 6, className = "" }) => (
  <span
    className={`${styles.skeleton} ${className}`.trim()}
    style={{ width, height, borderRadius: radius }}
    aria-hidden="true"
  />
);

export default Skeleton;
